import { render, staticRenderFns } from "./NewBanner.vue?vue&type=template&id=1073b821&scoped=true"
import script from "./NewBanner.vue?vue&type=script&lang=js"
export * from "./NewBanner.vue?vue&type=script&lang=js"
import style0 from "./NewBanner.vue?vue&type=style&index=0&id=1073b821&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1073b821",
  null
  
)

export default component.exports